export function isPlayerOwnedSession(session) {
  const owner = session?.ts_owner_player_id;
  return owner != null && String(owner).trim() !== "";
}

export function paddedPlayerSessionCode(sessionNumber) {
  const n = Number(sessionNumber);
  if (!Number.isFinite(n) || n <= 0) return null;
  return `P${String(n).padStart(3, "0")}`;
}

/** Hash fragment for titles: `P001` or `42`. */
export function formatTrainingSessionHash(session) {
  const n = Number(session?.ts_session_number);
  if (!Number.isFinite(n) || n <= 0) return null;
  if (isPlayerOwnedSession(session)) return paddedPlayerSessionCode(n);
  return String(n);
}

export function formatTrainingSessionLabel(session, t) {
  const hash = formatTrainingSessionHash(session);
  if (!hash) {
    return session?.name || "";
  }
  if (isPlayerOwnedSession(session)) {
    return t
      ? t("playerSessionNumber", { number: hash, defaultValue: `Session #${hash}` })
      : `Session #${hash}`;
  }
  return t
    ? t("trainingSessionNumber", {
        number: session.ts_session_number,
        defaultValue: `Training session #${session.ts_session_number}`,
      })
    : `Session #${hash}`;
}
